var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImageBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 210,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 315,
    height: 210
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311 0H4a4 4 0 0 0-4 4v202a4 4 0 0 0 4 4h307a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311 0H4a4 4 0 0 0-4 4v202a4 4 0 0 0 4 4h307a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Z",
    fill: "#E2E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 191 50.987-55.034c6.67-7.199 17.877-7.728 25.196-1.191l20.315 18.148c6.909 6.171 17.373 6.091 24.186-.184l94.092-86.665c6.82-6.28 17.295-6.355 24.202-.17L315 133.973",
    stroke: "#AFB6B9",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 101c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35Z",
    stroke: "#AFB6B9",
    strokeWidth: 8
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311 1H4a3 3 0 0 0-3 3v202a3 3 0 0 0 3 3h307a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Z",
    stroke: "#707B7F",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImageBg);
export default __webpack_public_path__ + "static/media/default-image-bg.91ed34a8524f6ac920f9237611adf27e.svg";
export { ForwardRef as ReactComponent };